import React from 'react';

export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="card p-12 text-center">
      {Icon && (
        <div className="w-12 h-12 bg-surface-100 rounded-xl flex items-center justify-center mx-auto mb-4">
          <Icon size={22} className="text-ink-muted" />
        </div>
      )}
      <h3 className="font-semibold text-ink mb-1">{title}</h3>
      {description && <p className="text-sm text-ink-secondary mb-5 max-w-xs mx-auto">{description}</p>}
      {action}
    </div>
  );
}
